import styled from 'styled-components';

const getSwitchBackgroundColor = (
  checked: boolean,
  disabled: boolean,
  theme: any
) => {
  if (disabled) {
    return 'rgba(0, 0, 0, 0.05)';
  } else if (checked) {
    return theme.palette.primary;
  } else {
    return 'rgba(223, 223, 223, 1)';
  }
};

export const SwitchContainer = styled.div<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${({ width }) => (width ? width : 'inherit')};
`;

export const SwitchButtonContainer = styled.div<{
  checked: boolean;
  disabled: boolean;
  loading: boolean;
}>`
  width: 44px;
  height: 28px;
  border-radius: 50px;
  background-color: ${({ checked, disabled, theme }) =>
    getSwitchBackgroundColor(checked, disabled, theme)};
  cursor: pointer;
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;

  ${({ loading }) =>
    loading
      ? `
    color: rgba(0, 0, 0, 0.9);
    z-index: 20;
    opacity: 0.3;
    cursor: not-allowed;`
      : null}
`;

export const ToggleButton = styled.div<{
  checked: boolean;
  disabled: boolean;
  loading: boolean;
}>`
  position: absolute;
  padding: 12px 12px;
  border-radius: 12px;
  cursor: ${({ loading }) => (loading ? 'not-allowed' : 'pointer')};
  background-color: ${({ disabled }) =>
    disabled ? 'rgba(0, 0, 0, 0.045)' : 'rgba(255, 255, 255, 1)'};
  color: white;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  left: ${({ checked }) => (checked ? '18px' : '2px')};
  transition: all 0.3s ease;
`;

export const Label = styled.div``;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
